import React, { useState } from "react";
import Modal from "react-bootstrap/esm/Modal";
import {closeShopifyCart} from "./components/actionCreators/shopifyAC";
import PromoMessages from "./components/PDP/Columns/PromoMessages";
import {filterPromoMessages} from "./components/actionCreators/appAC";
import InlineSpinner from "./components/common/InlineSpinner";
import CartHeader from "./components/cart/common/CartHeader";
import CartHowToPayHeader from "./components/cart/rewards-plus/CartHowToPayHeader";
import { useDispatch, useSelector } from "react-redux";
import { lazy } from "react";

const Cart = lazy(() => import('./components/cart'));

const CartContainer = () => {
    const dispatch = useDispatch();
    const [showRewardsAlternatePaymentOption, setShowRewardsAlternatePaymentOption] = useState(false);

    const { promo_messages, cartCount, isCartOpen, is_cart_busy } = useSelector(state => ({
        promo_messages: state.appReducer.promo_messages,
        cartCount: state.shopifyReducer.cartCount,
        isCartOpen: state.shopifyReducer.isCartOpen,
        is_cart_busy: state.shopifyReducer.is_cart_busy,
    }));

    const dismissCart = (is_cart_busy = false) => {
        if (!is_cart_busy) {
            document.querySelector(".cart-popup > .modal-dialog").classList.remove("cart-animation");
            setTimeout(function () {
                dispatch(closeShopifyCart());
            }, 400);
        }
    }

    const trade_in_bags = sessionStorage.getItem("trade_in_bags") ? JSON.parse(sessionStorage.getItem("trade_in_bags")) : [];
    const trade_in_bags_count = trade_in_bags.length;
    const cart_promo_messages = filterPromoMessages(promo_messages, [], 'show_in_cart');

    if (!isCartOpen) {
        return null;
    }

    return (
        <Modal
            show={true}
            centered
            onHide={() => dismissCart(is_cart_busy)}
            className={`cart-popup ${cartCount === 0 && trade_in_bags_count === 0 ? "cart-popup--empty" : ""}`}
            container={document.getElementById('react-popup-container')}
            backdropClassName="dark-overlay"
        >
            {is_cart_busy &&
                <InlineSpinner
                    custom_class="inline-spinner-container"
                />
            }
            {cart_promo_messages && cart_promo_messages.length > 0 &&
                <div className={`cart-popup__promo-messaging ${cart_promo_messages.length > 1 ? "promo-messaging-carousel" : ""}`}>
                    <PromoMessages
                        promo_messages={cart_promo_messages}
                    />
                </div>
            }
            {showRewardsAlternatePaymentOption ?
                <CartHowToPayHeader
                    setShowRewardsAlternatePaymentOption={setShowRewardsAlternatePaymentOption}
                />
                :
                <CartHeader dismissCart={() => dismissCart()} />
            }
            <Cart closeCart={() => dismissCart(is_cart_busy)}
                showRewardsAlternatePaymentOption={showRewardsAlternatePaymentOption}
                setShowRewardsAlternatePaymentOption={setShowRewardsAlternatePaymentOption}
            />
        </Modal>
    )
}

export default CartContainer;
